import NiceModal from '@ebay/nice-modal-react'

import { ILoadedScript } from '#state'

import { MoresAndContinuedsModal } from './MoresAndContinueds'

export const showMoresAndContinuedsModal = (script: ILoadedScript) =>
  NiceModal.show(MoresAndContinuedsModal, { script })
